module.exports = __webpack_public_path__ + "img/5.f0f981d4.jpg";